export const TIME_PATTERNS = {
  HH_MM_A: 'hh:mm a', // 03:45 PM
  HHMM_A: 'hhmm a', // 0345 PM
  HHA: 'hh a', // 3 PM
  HH_MM: 'HH:mm', // 15:30 (24h)
  HHMM: 'HHmm', // 1530 (24h)

  // With seconds (12h and 24h)
  HH_MM_SS_A: 'hh:mm:ss a', // 03:45:35 PM
  HH_MM_SS: 'HH:mm:ss', // 14:45:35

  // With milliseconds
  HH_MM_SS_SSS_A: 'hh:mm:ss.SSS a', // 03:45:35.300 PM
  HH_MM_SS_SSS: 'HH:mm:ss.SSS', // 14:45:35.300
};
